import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [listings, setListings] = useState([]);
  const [filterListing, setFilterListing] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = filterListing ? { listing_id: filterListing } : {};
    setLoading(true);
    api.get('/admin/leads', { params })
      .then(r => { setLeads(r.data.leads || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [filterListing]);

  useEffect(() => {
    api.get('/admin/listings').then(r => setListings(r.data.listings || [])).catch(() => {});
  }, []);

  const grouped = leads.reduce((acc, lead) => {
    const key = lead.listing_id;
    if (!acc[key]) acc[key] = { listing_title: lead.listing_title, leads: [] };
    acc[key].leads.push(lead);
    return acc;
  }, {});

  return (
    <div>
      <div className="section-tag">Admin</div>
      <h1 className="section-title">BUYER <span style={{ color: 'var(--neon-pink)' }}>LEADS</span></h1>
      <p style={{ color: 'var(--muted)', fontFamily: 'Space Mono, monospace', fontSize: '0.75rem', margin: '0.5rem 0 1.5rem' }}>
        {leads.length} total interest submissions
      </p>

      <div className="form-group" style={{ maxWidth: '400px', marginBottom: '1.5rem' }}>
        <label className="form-label">Filter by listing</label>
        <select className="form-select" value={filterListing} onChange={e => setFilterListing(e.target.value)}>
          <option value="">All listings</option>
          {listings.map(l => <option key={l.id} value={l.id}>{l.title}</option>)}
        </select>
      </div>

      {loading ? (
        <div className="loading"><div className="spinner" /></div>
      ) : leads.length === 0 ? (
        <div className="card">
          <div className="stat-sub">No interest submissions yet.</div>
        </div>
      ) : filterListing ? (
        // Flat table when filtered by listing
        <div className="card">
          <div style={{ overflow: 'auto' }} className="thin-scroll">
            <table className="data-table" style={{ minWidth: '800px' }}>
              <thead>
                <tr><th>Name</th><th>Email</th><th>Organisation</th><th>Type</th><th>Volume Interest</th><th>Notes</th><th>Date</th></tr>
              </thead>
              <tbody>
                {leads.map(lead => (
                  <tr key={lead.id}>
                    <td style={{ fontWeight: 600, fontSize: '0.82rem' }}>{lead.name}</td>
                    <td><a href={`mailto:${lead.email}`} style={{ color: 'var(--neon-cyan)', fontSize: '0.72rem', textDecoration: 'none' }}>{lead.email}</a></td>
                    <td style={{ color: 'var(--muted)', fontSize: '0.72rem' }}>{lead.organisation}</td>
                    <td><span className="badge badge-muted" style={{ fontSize: '0.55rem' }}>{lead.buyer_type}</span></td>
                    <td style={{ color: 'var(--neon-green)', fontFamily: 'Space Mono, monospace', fontSize: '0.72rem' }}>{lead.volume_interest || '—'}</td>
                    <td style={{ color: 'var(--muted)', fontSize: '0.72rem', maxWidth: '200px' }}>{lead.notes || '—'}</td>
                    <td style={{ color: 'var(--muted2)', fontSize: '0.65rem', whiteSpace: 'nowrap' }}>{new Date(lead.created_at).toLocaleDateString('en-IN')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        // Grouped by listing
        <div style={{ display: 'grid', gap: '1.5rem' }}>
          {Object.entries(grouped).map(([listingId, group]) => (
            <div key={listingId} className="card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '0.5rem' }}>
                <div>
                  <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, fontSize: '0.92rem' }}>{group.listing_title}</div>
                  <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.62rem', color: 'var(--muted)', marginTop: '0.2rem' }}>{group.leads.length} lead{group.leads.length !== 1 ? 's' : ''}</div>
                </div>
                <button className="btn btn-sm btn-secondary" onClick={() => setFilterListing(listingId)}>View all</button>
              </div>
              <div style={{ overflow: 'auto' }} className="thin-scroll">
                <table className="data-table" style={{ minWidth: '700px' }}>
                  <thead>
                    <tr><th>Name</th><th>Email</th><th>Organisation</th><th>Type</th><th>Volume</th><th>Date</th></tr>
                  </thead>
                  <tbody>
                    {group.leads.slice(0, 5).map(lead => (
                      <tr key={lead.id}>
                        <td style={{ fontWeight: 600, fontSize: '0.82rem' }}>{lead.name}</td>
                        <td><a href={`mailto:${lead.email}`} style={{ color: 'var(--neon-cyan)', fontSize: '0.72rem', textDecoration: 'none' }}>{lead.email}</a></td>
                        <td style={{ color: 'var(--muted)', fontSize: '0.72rem' }}>{lead.organisation}</td>
                        <td><span className="badge badge-muted" style={{ fontSize: '0.55rem' }}>{lead.buyer_type}</span></td>
                        <td style={{ color: 'var(--neon-green)', fontFamily: 'Space Mono, monospace', fontSize: '0.72rem' }}>{lead.volume_interest || '—'}</td>
                        <td style={{ color: 'var(--muted2)', fontSize: '0.65rem', whiteSpace: 'nowrap' }}>{new Date(lead.created_at).toLocaleDateString('en-IN')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
